import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
import { CalendarDays } from "lucide-react";

const fmt = (v) => v ? new Date(v + "T00:00:00").toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "";
const toStr = (d) => { const p = (n) => String(n).padStart(2, "0"); return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`; };

export const DatePicker = ({ value, onChange, className = "", testId, placeholder = "Pick a date" }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testId}
                className={`w-full justify-start font-normal bg-white hover:bg-slate-50 ${value ? "text-slate-800" : "text-slate-400"} ${className}`}>
          <CalendarDays size={14} className="mr-2 text-slate-400 flex-none" />
          <span className="truncate">{value ? fmt(value) : placeholder}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={value ? new Date(value + "T00:00:00") : undefined}
                  onSelect={(d) => { onChange(d ? toStr(d) : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
